import { Observable } from 'rxjs';

export default {
    data: function () {
        return {
            scrollObserver: null,
            scrollPageSubscriberList: []
        };
    },
    created: function () {
        this.initScrollPage();
    },
    beforeDestroy: function() {
        window.onscroll = null;
    },
    methods: {
        initScrollPage: function () {
            this.scrollObserver = new Observable(subscriber => {
                this.scrollPageSubscriberList.push(subscriber);
            });

            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );

                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                if (bottomOfWindow) {
                    this.eventToBottom(true);
                } else {
                    this.eventToBottom(false);
                }
            };
        },
        eventToBottom: function(isBottom) {
            for (var i of this.scrollPageSubscriberList) {
                i.next(isBottom);
            }
        }
    }
}
